import React from 'react'

export const VersionInfo: React.FC = () => {
  const version = import.meta.env.VITE_VERSION

  // eslint-disable-next-line no-console
  console.info(
    `version: ${version || 'No version information present at build time'}`
  )

  return null
}
